import { React, useState,useContext,useEffect,useRef } from 'react'
import { FaBars } from "react-icons/fa";
import { useNavigate, useLocation } from "react-router-dom";
import axios from '../../api/axios';
import { GlobalContext } from '../../App';
import Slidebar from './Slidebar';
import { FormGroup, Col, Label, Input, Form, Row } from 'reactstrap'
import Select from 'react-select';
import { toast } from 'react-toastify';
import ReactQuill from 'react-quill';
import Profile from '../../assets/images/profile-img.png';

function TopHeader(props) {
  const body = document.body;
  // const mainPanel = document.querySelector('.main-panel');
  const maskBgOverlay = document.createElement('div');
  maskBgOverlay.id="maskBgOverlay";
  maskBgOverlay.className = 'maskBgOverlay';
  const navigate = useNavigate();
  const location = useLocation();
  const { rolexModuleData,user_id,userProfile,roles } = useContext(GlobalContext);
  function openSideBar() {
    // document.getElementById("showSideBar").style.width = "250px";
    document.getElementById("pageWrapper").style.width = "calc(100% - 250px)";
    document.getElementById("sidebarWrapper").style.width = "250px";
    document.getElementById("pageWrapper").style.marginLeft = "250px";
    setIsopen(true);
  }
  function closeSideBar() {
      // document.getElementById("showSideBar").style.width = "65px";
      document.getElementById("pageWrapper").style.width = "100%";
      document.getElementById("sidebarWrapper").style.width = "0";
      document.getElementById("pageWrapper").style.marginLeft = "0";
      setIsopen(false);
  }
  /** Display Sidebar Menu **/
  const [isOpen, setIsopen] = useState(true);
  const ToggleSidebar = () => { isOpen === true ?  closeSideBar() : openSideBar()}
  const [openMenu, setOpenMenu] = useState(false); 
  
  /** End Display Sidebar Menu */
// autoclose menubar//
const dropdownRef = useRef(null);
const handleDropdownToggle = () => {
  setOpenMenu((prevState) => !prevState);
};
const handleOutsideClick = (event) => {
  if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
    setOpenMenu(false);
  }
};
// End Autoclose//
// profile dropdown//

const logout = () => {
  try {
    axios.post('/logout', {
      user_id: user_id
      
    }).then(()=>{
      navigate('/');
      window.location.reload(false);
    });   
  } catch (err) {
    console.error(err);
    navigate('/', { state: { from: location }, replace: true });
  }
}
  
  // -------------------------------------------------------- Use Effect -----------------------------------------
  useEffect(() => {    
    if (isOpen) {
      document.addEventListener('mousedown', handleOutsideClick);
    } else {
      document.removeEventListener('mousedown', handleOutsideClick);
    }
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };  
  }, [isOpen])
//end profile//
  return (
      <>
        <div className='top-header'>
          <button type="button" className="header-toggler ps-1">
            {isOpen? <FaBars onClick={() => ToggleSidebar()}/> : < FaBars onClick={() => ToggleSidebar()}/>} 
          </button>      
          <ul className="header-nav breadcrumb d-none d-md-flex me-auto">
              {props.breadCrumb}
          </ul>        
          <ul className="header-nav ps-0">
            <li className="nav-item dropdown" >
              <a onClick={()=>setOpenMenu(!openMenu)} className="nav-link" title="Profile" aria-expanded="false" >
                <div className="avatar">
                <img alt="User Profile Images" src={props?.userData?.profileImageUrl?.length ? (props?.userData?.profileImageUrl) : userProfile?.profileImageUrl?.length > 0 ? (userProfile?.profileImageUrl) : Profile}/>
                </div>
              </a>
              <div className='outsideclick'  id="menu-checkbox" ref={dropdownRef}>
              <ul className= { openMenu ? "dropdown-menu dropdown-menu-end pt-0 show": "dropdown-menu dropdown-menu-end pt-0" } role="menu" aria-hidden="false" onClick={handleDropdownToggle}>
                <li>
                  <h6 className="dropdown-header"><strong>{props?.userData?.name || userProfile?.name}</strong></h6>
                </li>
                {((rolexModuleData?.find((data) => data?.description === '/personal-detail' && data?.read === 1) )|| roles?.find((data) => data?.role_id === 1001) )?
             <li>
             <a onClick={() => navigate("/personal-detail")} className="dropdown-item">
               <span>Profile</span>
             </a>
           </li> : null}                  
                <li>
                  <a onClick={logout} className="dropdown-item">
                    <span>Logout</span>
                  </a>
                </li>
              </ul>
              </div>
            </li>
          </ul>
        </div>
      </>
  )
}
export default TopHeader